// extracted by mini-css-extract-plugin
export default {"nav":"styles---nav---LSkRb","activeTab":"styles---activeTab---SwuQE"};